import {
  UPDATE_USER_ID,
  UPDATE_USER_USERNAME,
  UPDATE_USER_PASSWORD,
  UPDATE_USER_PROFILE,
  POST_LOGIN_USER,
  POST_LOGIN_USER_START,
  POST_LOGIN_USER_SUCCESS,
  POST_LOGIN_USER_ERROR,
  POST_LOGOUT_USER,
  POST_LOGOUT_USER_START,
  POST_LOGOUT_USER_SUCCESS,
  POST_LOGOUT_USER_ERROR,
  CLEAR_USER_ATTRIBUTES,
  CLEAR_USER_ID,
  UPDATE_AUTHENTICATED,
  CLEAR_SHOW_ERROR,
  UPDATE_SHOW_ERROR,
} from './constants'
import {
  buildAsyncAction,
} from 'containers/Async/actions'

const clearShowError = () => ({ type: CLEAR_SHOW_ERROR })
const updateShowError = (show) => ({ type: UPDATE_SHOW_ERROR, show })
const clearUserAttributes = () => ({ type: CLEAR_USER_ATTRIBUTES })
const clearUserId = () => ({ type: CLEAR_USER_ID })
const updateUserId = (id) => ({ type: UPDATE_USER_ID, id })
const updateUsername = (username) => ({ type: UPDATE_USER_USERNAME, username })
const updatePassword = (password) => ({ type: UPDATE_USER_PASSWORD, password })
const updateUserProfile = (attributes) => ({ type: UPDATE_USER_PROFILE, ...attributes })
const updateAuthenticated = (authenticated) => ({ type: UPDATE_AUTHENTICATED, authenticated })
const postLoginUser = () => ({ type: POST_LOGIN_USER })
const postLoginUserStart = () => ({ type: POST_LOGIN_USER_START })
const postLoginUserSuccess = () => ({ type: POST_LOGIN_USER_SUCCESS })
const postLoginUserError = (error) => ({ type: POST_LOGIN_USER_ERROR, error })
const postLogoutUser = () => ({ type: POST_LOGOUT_USER })
const postLogoutUserStart = () => ({ type: POST_LOGOUT_USER_START })
const postLogoutUserSuccess = () => ({ type: POST_LOGOUT_USER_SUCCESS })
const postLogoutUserError = (error) => ({ type: POST_LOGOUT_USER_ERROR, error })
const startLoginUserAsync = buildAsyncAction(
  POST_LOGIN_USER,
  POST_LOGIN_USER_START,
  [POST_LOGIN_USER_SUCCESS, POST_LOGIN_USER_ERROR]
)

export {
  startLoginUserAsync,
  clearUserId,
  clearUserAttributes,
  clearShowError,
  updateShowError,
  updateAuthenticated,
  updateUserId,
  updateUsername,
  updatePassword,
  updateUserProfile,
  postLoginUser,
  postLoginUserStart,
  postLoginUserSuccess,
  postLoginUserError,
  postLogoutUser,
  postLogoutUserStart,
  postLogoutUserSuccess,
  postLogoutUserError,
}
